import { stayMoments } from '../constants';

export function MomentsSection() {
    return (
        <section
            id="moments"
            className="grid gap-4 rounded-3xl border border-slate-200/60 bg-white/80 p-10 shadow-sm backdrop-blur-sm dark:border-slate-700/60 dark:bg-gray-900/70"
        >
            <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <div>
                    <h2 className="text-2xl font-semibold text-slate-900 dark:text-white">
                        Stay moments that linger
                    </h2>
                    <p className="text-sm text-slate-500 dark:text-slate-400">
                        Thoughtfully designed spaces that invite you to take
                        your time and savor each phase of your stay.
                    </p>
                </div>
                {/* <Button
                    asChild
                    variant="ghost"
                    className="text-slate-700 hover:text-slate-900 dark:hover:text-white"
                >
                    <Link
                        href={register()}
                        className="flex items-center gap-2"
                    >
                        Build my itinerary
                        <ArrowRight className="size-4" />
                    </Link>
                </Button> */}
            </div>
            <div className="grid gap-5 md:grid-cols-3">
                {stayMoments.map((moment) => (
                    <div
                        key={moment.label}
                        className="space-y-3 rounded-2xl border border-slate-200/60 bg-white/60 p-6 text-slate-700 shadow-sm transition hover:border-slate-300 hover:shadow-md dark:border-slate-700/60 dark:bg-gray-900/60 dark:text-slate-300 dark:hover:border-slate-500"
                    >
                        <h3 className="text-base font-semibold text-slate-900 dark:text-white">
                            {moment.label}
                        </h3>
                        <p className="text-sm leading-relaxed">
                            {moment.detail}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}
